import React, {Component} from 'react';
import 'flatpickr/dist/themes/airbnb.css'
import FlatpickrL10n from 'flatpickr/dist/l10n/nl'
import Flatpickr from 'react-flatpickr'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {navigateTo} from 'gatsby-link';

import * as SimplyBookService from '../../services/simplyBookService';
import * as SimplybookActions from '../../store/actions/simplyBook.actions';

class AvailabilityWidget extends Component {
    constructor(props){
        super(props);

        this.state = {
            eventDate: '',
            eventType: '',
            notAvailable: false
        };
    }

    componentWillMount(){
        if(!this.props.simplyBook.initiated){
            this.props.simplybookActions.getEvents();
        }

        if(this.props.reservation && this.props.simplyBook.newEvent && this.props.simplyBook.newEvent.event){
            this.prefillComponent();
        }
    }

    prefillComponent(){
        this.setState({
            eventDate: this.props.simplyBook.newEvent.event.eventDate,
            eventType: this.props.simplyBook.newEvent.event.eventId,
            hideButton: true,
            checkingAvailability: false
        })
    }

    checkAvailability(event){
        event.preventDefault();

        // Reset state
        this.setState({
            checkingAvailability: true,
            notAvailable: false
        });

        let newEvent = {
            eventId: this.state.eventType,
            eventDate: this.state.eventDate
        };

        SimplyBookService.checkAvailability(newEvent)
            .then((response) => {
                if(response.data.result.length === 0){
                    this.setState({
                        checkingAvailability: false,
                        notAvailable: true
                    });
                }else{
                    this.props.simplybookActions.prepareBooking(response.data.result, newEvent);

                    // Update state or navigate to reservation page
                    if(this.props.reservation){
                        this.prefillComponent()
                    }else{
                        navigateTo('/reserveren');
                    }
                }
            })
            .catch((error) => {
                this.setState({
                    checkingAvailability: false,
                    notAvailable: true
                })
            })
    }

    renderEventOptions(){
        let {events} = this.props.simplyBook;
        return Object.keys(events).map((key) => {
            return (
                <option key={key} value={events[key].id}>{events[key].name}</option>
            )
        })
    }

    handleDatePicker(value){
        if(value.length){
            this.props.simplybookActions.resetEvent();
            this.setState({
                eventDate: value[0],
                hideButton: false
            })
        }
    }

    handleSelect(event){
        this.props.simplybookActions.resetEvent();
        this.setState({
            eventType: event.target.value,
            hideButton: false
        })
    }

    render(){
        return (
            <form className="availabilityWidget has-padding-bottom" onSubmit={(event) => this.checkAvailability(event)}>
                <div className="columns">
                    <div className="column">
                        <div className="select is-fullwidth is-medium">
                            <select name={'eventType'} value={this.state.eventType} onChange={this.handleSelect.bind(this)} required>
                                <option value="">Selecteer een photobooth</option>
                                { this.renderEventOptions() }
                            </select>
                        </div>
                    </div>
                    <div className="column">
                        <Flatpickr
                            required="required"
                            options={
                                {
                                    locale: FlatpickrL10n['nl'],
                                    altInput: true,
                                    minDate: new Date().fp_incr(1),
                                    maxDate: new Date().fp_incr(365)
                                }
                            }
                            name={'eventDate'}
                            value={this.state.eventDate}
                            placeholder="Datum van evenement" className="input is-medium is-fullwidth" onChange={(data) => this.handleDatePicker(data)} />
                    </div>
                    { !this.state.hideButton &&
                    <div className="column">
                        <button
                            disabled={(this.state.eventDate && this.state.eventType) ? undefined : 'disabled'}
                            className={`button is-primary is-medium is-fullwidth ${this.state.checkingAvailability ? 'is-loading' : ''}`}>
                            Check!
                        </button>
                    </div>
                    }
                </div>
                {
                    this.state.notAvailable &&
                    <div className="notification is-danger">
                        Helaas, de photobooth die jij wilt boeken is op de geselecteerde datum niet beschikbaar. Kies een andere photobooth of bel met <a href="tel:0644066185">+31 (0)6 - 440 661 85</a> om te achterhalen wat de overige mogelijkheden zijn.
                    </div>
                }
            </form>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        simplyBook: state.simplyBook
    }
};

const mapDispatchToProps = (dispatch) => ({
    simplybookActions: bindActionCreators(SimplybookActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityWidget);



// WEBPACK FOOTER //
// ./src/components/availability-widget/index.js